import { render, staticRenderFns } from "./OnboardingStepHowDidYouFindUs.vue?vue&type=template&id=c05c49b6"
import script from "./OnboardingStepHowDidYouFindUs.vue?vue&type=script&lang=js"
export * from "./OnboardingStepHowDidYouFindUs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports